export default "__VITE_ASSET__DN1hdEQz__"